"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.delete.confirm.title': 'Eliminar Pregunta',
    'question.delete.confirm.message': '¿Está seguro de que desea eliminar esta pregunta?',
};
